import colorPallete, { bodyFonts, headlineFonts, labelFonts, themeFontWeights } from "@DSG/MobiusOverrides/styles/variables";
import Zone from "@insite/client-framework/Components/Zone";
import {
    ExcludeFromNavigation,
    ExcludeFromSignInRequired,
    HideFooter,
    HideHeader,
    MetaDescription,
    MetaKeywords,
    OpenGraphImage,
    OpenGraphTitle,
    OpenGraphUrl,
} from "@insite/client-framework/Types/FieldDefinition";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Modals from "@insite/content-library/Components/Modals";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import * as React from "react";
import { css } from "styled-components";

export interface HomePageStyles {
    page?: MobiusPageProps;
}

export const homePageStyles: HomePageStyles = {
    page: {
        css: css`
            padding-top: 24px;
            padding-bottom: 80px;
            ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        null,
                        null,
                        css`
                            padding: 24px;
                        `,
                        null,
                    ], "min")}

            @media only screen and (max-width: 768px) {
                padding-bottom: 24px;
            }
          
        
            > div[class*="Wrapper--"] {
                > div[class*="GridWrapper--"] {
                    max-width: 100%;
                    @media only screen and (min-width: 1439px) {
                        max-width: 1440px;
                    }
                    > div[class*="GridOffset--"] {
                        width: 100%;
                        margin: 0;
                        > div[class*="GridItemStyle--"] {
                            padding: 0;
                        }
                    }
                }
            }

            .recommendation-carousel {
                max-width: 1280px;
                > [class*="GridOffset--"] {
                    margin: 0;
                    width: 100%;
                }
            }

            .one-team-section {
                border-radius: 8px;
                margin-bottom: 48px;
                @media only screen and (max-width: 768px) {
                    margin-bottom: 48px;
                }
            }

            .branch-opening-section {
                margin-bottom: 80px;
                border-radius: 8px;

                > [class*="GridOffset--"] {
                    border-radius: 8px;
                }

                [class*="ContentWrapper--"] {
                    padding-left: 160px;
                    @media only screen and (min-width: 768px) {
                        border-top-left-radius: 8px;
                        border-bottom-left-radius: 8px;
                    }
                }

                [class*="GridItemStyle--"] {
                    div {
                        height: 100%;
                    }
                }

                img {
                    display: block;
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    @media only screen and (min-width: 768px) {
                        border-top-right-radius: 8px;
                        border-bottom-right-radius: 8px;
                    }
                }

                @media only screen and (min-width: 768px) and (max-width: 1024px) {
                    > div[class*="GridOffset--"] {
                        div[class*="ContentWrapper--"] {
                            padding: 40px;
                        }
                    }
                }

                @media only screen and (max-width: 768px) {
                    margin-bottom: 48px;

                    > div[class*="GridOffset--"] {
                        flex-direction: column-reverse;

                        div[class*="ContentWrapper--"] {
                            padding: 40px;
                        }
                    }
                }
            }

            .online-billpay-section {
                max-width: 1280px;
                padding-bottom: 48px;
                @media only screen and (max-width: 768px) {
                    padding: 0 16px;
                    padding-bottom: 24px;
                }
                .billpay-wrapper {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    h2 {
                        font-size: ${headlineFonts.headline2SemiBoldLg.fontSize};
                        line-height: ${headlineFonts.headline2SemiBoldLg.lineHeight};
                        font-weight: ${themeFontWeights.semiBold};
                        color: ${colorPallete.white};
                        margin-bottom: 0;

                        @media only screen and (max-width: 768px) {
                            font-size: ${headlineFonts.headline2SemiBoldSm.fontSize};
                            line-height: ${headlineFonts.headline2SemiBoldSm.lineHeight};
                        }
                    }

                    @media only screen and (max-width: 1024px) {
                        flex-direction: column;
                    }

                    @media only screen and (max-width: 540px) {
                        align-items: flex-start;

                        .btn {
                            align-self: center;
                        }
                    }
                }

                div[class*="ContentWrapper--"] {
                    padding-left: 80px;
                    padding-right: 80px;
                    border-radius: 8px;
                    @media only screen and (max-width: 768px) {
                        padding: 32px 40px;
                    }
                }

                .billpay-header {
                    display: flex;
                    align-items: center;
                    gap: 24px;
                    @media only screen and (max-width: 1024px) {
                        margin-bottom: 16px;
                    }

                    @media only screen and (max-width: 768px) {
                        img {
                            max-width: 66px;
                        }
                    }
                }

                .billpay-description {
                    color: ${colorPallete.white};
                    p {
                        color: ${colorPallete.white};
                        font-size: ${bodyFonts.body1RegularLg.fontSize};
                        line-height: ${bodyFonts.body1RegularLg.lineHeight};
                        margin-bottom: 0;
                        @media only screen and (max-width: 768px) {
                            font-size: ${bodyFonts.body1RegularLg.fontSize};
                            line-height: ${bodyFonts.body1RegularLg.lineHeight};
                        }
                    }
                    @media only screen and (max-width: 1024px) {
                        margin-bottom: 24px;
                    }
                }
            }

            .testimonial-carousel-row {
                max-width: 1116px;
                @media only screen and (max-width: 768px) {
                    margin-bottom: 48px;
                }
            }

            .dsg-plus-section {
                max-width: 1280px;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                padding: 0 16px;
                            `,
                            css`
                                padding: 0 16px;
                            `,
                            css`
                                padding: 0 24px;
                            `,
                            css`
                                padding: 0 24px;
                            `,
                        ],
                        "min",
                    )}

                @media only screen and (min-width: 1280px) {
                    padding: 0;

                    & > div[class*="GridOffset--"] { 
                        width: 100%;
                    }
                }

                div[class*="GridItemStyle--"],
                div[class*="ContentWrapper--"] {
                    border-radius: 8px;
                    max-height: 356px;
                }

                div[class*="GridItemStyle--"] {
                    * div,
                    > div {
                        height: 100%;
                    }
                }

                .img-wrapper {
                    img {
                        display: block;
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        border-radius: 8px;
                        max-height: 356px;

                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(theme, [
                                null,
                                css`
                                    min-height: 280px;
                                    max-height: 280px;
                                `,
                                null,
                                null,
                            ], "max")}
                    }
                }

                @media only screen and (max-width: 768px) {
                    div[class*="ContentWrapper--"] {
                        padding: 40px;
                    }
                }
            }

            .dsg-plus-content-wrapper {
                .dsg-plus-title {
                    font-size: ${headlineFonts.headline2SemiBoldLg.fontSize};
                    font-weight: ${headlineFonts.headline2SemiBoldLg.fontWeight};
                    color: ${colorPallete.grey800};
                    @media only screen and (max-width: 768px) {
                        font-size: ${headlineFonts.headline2SemiBoldLg.fontSize};
                        line-height: ${headlineFonts.headline2SemiBoldLg.lineHeight};
                    }
                }
                .dsg-plus-description {
                    font-size: ${bodyFonts.body1RegularLg.fontSize};
                    line-height: ${bodyFonts.body1RegularLg.lineHeight};
                    color: ${colorPallete.grey800};
                    margin-bottom: 24px;
                    @media only screen and (max-width: 768px) {
                        font-size: ${bodyFonts.body1RegularSm.fontSize};
                        line-height: ${bodyFonts.body1RegularSm.lineHeight};
                    }
                }

                &.content-light {
                    .dsg-plus-title,
                    .dsg-plus-description {
                        color: ${colorPallete.white};
                    }
                }
            }

            .hover-grid-section {
                max-width: 1280px;
                margin-top: 20px;

                @media only screen and (max-width: 768px) {
                    margin-bottom: 24px;
                }

                [class*="GridOffset--"] {
                    gap: 16px;

                    @media only screen and (max-width: 768px) {
                        flex-direction: column;
                        align-items: center;
                    }
                }

                .hover-block-wrapper {
                    cursor: pointer;
                    flex: 1;
                    min-height: 375px;
                    div {
                        height: 100%;
                        min-height: 320px;
                    }
                    @media only screen and (max-width: 768px) {
                        width: 100%;
                        min-height: 320px;
                        min-width: 356px;
                    }
                }
            }

            .static-banner-wrapper {
                .justifySpaceBetween {
                    display: flex; 
                    justify-content: space-between; 
                    margin-bottom: 14px;
                    align-items: center;
                }
                .contentFullWidth {
                    width: 100%;
                }
                .image-icon {
                    img {
                        width: 56px;
                    }
                }
            }
            .hero-banner {
                .static-banner-wrapper {
                    .banner-content {p {
                            font-size: ${bodyFonts.body2RegularLg.fontSize};
                            line-height: ${bodyFonts.body2RegularLg.lineHeight};
                        }
                        h4 {
                            font: ${headlineFonts.headline5SemiBoldSm.fontWeight} ${headlineFonts.headline5SemiBoldSm.fontSize}/${headlineFonts.headline5SemiBoldSm.lineHeight} ${headlineFonts.headline5SemiBoldSm.fontFamily};
                            color: ${colorPallete.white};
                        }
                    }
                }
            }
            
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    null,
                    css`
                        .static-banner-wrapper {
                            .justifySpaceBetween {
                                margin-bottom: 10px;
                            }
                            .image-icon {
                                img {
                                    width: 64px;
                                }
                            }
                        }
                        .hero-banner {
                            .static-banner-wrapper {
                                .banner-content {p {
                                        font-size: ${bodyFonts.body2RegularLg.fontSize};
                                        line-height: ${bodyFonts.body2RegularLg.lineHeight};
                                        margin-bottom: 0;
                                    }
                                    h4 {
                                        font-size: ${headlineFonts.headline3SemiBoldSm.fontSize};
                                        line-height: ${headlineFonts.headline3SemiBoldSm.lineHeight};
                                        margin-bottom: 10px;
                                    }
                                }
                            }
                        }
                    `,
                ],
                "min",
            )}
            
            @media screen and (min-width: 1280px) {
                .loggedInUser {
                    .hero-banner-columns {
                        &:first-child {
                            max-width: calc(100% - 504px);
                            flex-basis: calc(100% - 504px);
                        }
                        &:last-child {
                            max-width: 496px;
                            flex-basis: 496px;
                            min-height: 370px
                        }
                    }
                }
            }
        
        `,
    },
};
const styles = homePageStyles;

const HomePage = ({ id }: PageProps) => (
    <Page data-test-selector="homePage" {...styles.page} fullWidth={[true, true, true, true, true]}>
        <Zone contentId={id} zoneName="Content" requireRows />
        <Modals />
    </Page>
);

const pageModule: PageModule = {
    component: HomePage,
    definition: {
        hasEditableTitle: true,
        hasEditableUrlSegment: true,
        pageType: "System",
        fieldDefinitions: [
            MetaKeywords,
            MetaDescription,
            OpenGraphTitle,
            OpenGraphUrl,
            OpenGraphImage,
            HideHeader,
            HideFooter,
            ExcludeFromNavigation,
            ExcludeFromSignInRequired,
        ],
    },
};

export default pageModule;

/**
 * @deprecated Use string literal "HomePage" instead of this constant.
 */
export const HomePageContext = "HomePage";
